import Loadable from '~/components/LoadableErrorReload';
import { useTraderProfileModerationFlag } from '~/hooks/useTraderProfileModerationFlag';
import NotFound from '~/pages/maintenance/404';
import { PagePolicies } from '~/utils/roles';

import { restrictPage } from './restrictPage';

const TraderProfilesModerationPage = Loadable(
  () => import('~/pages/dashboard/admin/trader-profiles/moderation'),
);

function TraderProfilesModerationFlagRoute() {
  const { isTraderProfileModerationEnabled } = useTraderProfileModerationFlag();
  return isTraderProfileModerationEnabled ? <TraderProfilesModerationPage /> : <NotFound />;
}

export const traderProfilesModerationRoute = {
  path: 'trader-profiles/moderation',
  element: restrictPage(
    <TraderProfilesModerationFlagRoute />,
    PagePolicies.AdminTraderProfilesModerationPage,
  ),
};
